"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _buttons = require("@vds-core/buttons");
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var propTypes = {
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool
};
var defaultProps = {
  inverted: false
};
var _calculateLetterSpacing = function _calculateLetterSpacing() {
  return (0, _javascriptStyleHelpers.calculateRem)("0.5px");
};
var _calculateActiveColor = function _calculateActiveColor() {
  return "#747676"; // CoolGray6
};

var TextLinkCaret = function TextLinkCaret(props) {
  return /*#__PURE__*/_react["default"].createElement(_buttons.TextLinkCaret, (0, _extends2["default"])({}, props, {
    surface: props.inverted ? "dark" : "light",
    focusRingBorderRadius: "0",
    calculateActiveColor: _calculateActiveColor,
    calculateLetterSpacing: _calculateLetterSpacing
  }));
};
TextLinkCaret.propTypes = propTypes;
TextLinkCaret.defaultProps = defaultProps;
var _default = exports["default"] = TextLinkCaret;